import { Box, Text, Touchable, useClassNames } from '@factorialco/deprecated-design-system'
import range from 'lodash/range'

import * as styles from './index.vanilla.css'

interface Props {
  firstYear: number
  selectedYear: number
  onSelectYear: (year: number) => void
}

type YearProps = {
  year: number
  selected?: boolean
  onSelected?: () => void
}

const Year = ({ year, selected, onSelected }: YearProps) => {
  const cx = useClassNames(styles)

  return (
    <Touchable onClick={onSelected}>
      <Box className={cx('year', { selected })}>
        <Text.Normal color={selected ? 'grey000White' : undefined} size="200" capitalize>
          {year}
        </Text.Normal>
      </Box>
    </Touchable>
  )
}

export const YearsGrid = ({ firstYear, selectedYear, onSelectYear }: Props) => {
  return (
    <Box alignItems="center" justifyContent="center" width="full">
      {range(4).map((row) => (
        <Box key={row} flexDirection="row">
          {range(3).map((blockYear) => {
            const year = firstYear + row * 3 + blockYear

            return (
              <Box key={blockYear} flexDirection="row" padding="s4">
                <Year
                  year={year}
                  selected={year === selectedYear}
                  onSelected={() => {
                    onSelectYear(year)
                  }}
                />
              </Box>
            )
          })}
        </Box>
      ))}
    </Box>
  )
}
